var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMhMarshallIslands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_20687)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 0H0.00937271V45H60V0Z",
    fill: "#3B5AA3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 43.7812L0.00937271 0V8.15625L60 45V43.7812Z",
    fill: "#E2AE57"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9 44.9998L0 16.7998L0.00937271 7.84668L60 44.9998H57.9ZM43.5563 1.4248L44.1562 11.0623L46.6875 4.9123L45.7125 11.4561L49.6406 6.16855L47.0625 12.1967L52.2188 8.20293L48.2062 13.2279L54.0281 10.6404L48.9281 14.5029L55.275 13.6592L49.275 16.0404L58.6875 16.9029L49.2563 17.5311L55.2281 19.9873L48.9469 19.1436L54.0375 22.8936L48.1313 20.3061L52.1625 25.3686L47.0438 21.4967L49.575 27.3936L45.4875 22.2654L46.5938 28.6498L44.0156 22.6779L43.4344 32.1186L42.525 22.7061L40.3031 28.7061L41.1469 22.2373L37.0781 27.3748L39.7594 21.3748L34.6406 25.4998L38.7094 20.3529L32.625 22.8842L38.0062 18.9561L31.4531 20.0623L37.7344 17.6529L27.975 17.0436L37.725 16.1342L31.3031 13.9967L37.9594 14.8404L32.4656 10.9967L38.6531 13.4811L34.3781 8.29668L39.5906 12.3654L37.0875 6.14043L41.1281 11.4279L40.2562 4.82793L42.6656 11.0623L43.5656 1.4248H43.5563Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_20687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMhMarshallIslands);
export default __webpack_public_path__ + "static/media/mh Marshall Islands.2a0edd6f3f07dbede83fcf47058dd0e5.svg";
export { ForwardRef as ReactComponent };